/*
 * @Author: linrui
 * @Date: 2021-12-24 09:38:38
 * @LastEditors: linrui
 * @LastEditTime: 2021-12-24 09:59:15
 * @FilePath: /wechat-frontend/zmtx/src/store/doctor/index.js
 */
export const doctor = {
    state:{
        doctorInfo:{},
        hasEre: null,
    },
    mutations: {
        setDoctorInfo(state, doctorInfo) {
            state.doctorInfo = doctorInfo
        },
        clearDoctorInfo(state) {
            state.doctorInfo = {}
        },
        setHasEre(state, hasEre) {
            state.hasEre = hasEre
        },
        clearHasEre(state) {
            state.hasEre = null
        }
    }
}